module.exports = __webpack_public_path__ + "img/爆竹.0f857c52.png";